import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {TabDirective, TabsetComponent} from 'ngx-bootstrap/tabs';
import {firstValueFrom, Subscription} from 'rxjs';
import {ActivatedRoute, Params} from '@angular/router';
import {ApiService, FactSheet} from '../_services/api.service';
import {LanguageService} from '../_services/language.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {FormDetail} from '../forms/file-online-v2/models/api/Form';

@Component({
    selector: 'app-leveltwo',
    templateUrl: './leveltwo.component.html',
    styleUrls: ['./leveltwo.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LeveltwoComponent implements OnInit, AfterViewInit {
  @Input() pageId;
  @Input() pageName;
  @Input() videos;
  @Input() news;
  @Input() notices;

  @Input() calculators = false;
  @Input() pastEvents = false;

  @ViewChild('staticTabs', {static: true}) staticTabs: TabsetComponent;

  id: number;
  lang: string;
  subscription: Subscription;
  tab = 'General Info';
  faq = true;
  fact = true;
  forms = true;
  enable = false;

  FaqData: any;
  FormData: any;
  factSheets: FactSheet[] = [];
  formDetails: FormDetail[] = [];

  loadingFactSheets = false;
  loadingFaq = false;
  loadingForms = false;

  constructor(private actRoute: ActivatedRoute,
              public apiService: ApiService,
              private languageService: LanguageService,
              private spinner: NgxSpinnerService,
              private cd: ChangeDetectorRef) {
    this.subscription = this.languageService.currentMessage.subscribe(message => {
      this.lang = message;
    });
  }

  ngAfterViewInit(): void {
    if (this.pageName) {
      this.apiService.getPage(this.pageName).subscribe(data => {
        if (!data) {
          return;
        }

        this.pageId = data.id;
        this.fact = data.fact;
        this.faq = data.faq;
        this.forms = data.file;
        this.enable = true;

        this.loadInitialTab();
      });
    }
  }

  ngOnInit(): void {
    this.spinner.show();
  }

  loadInitialTab(): void {
    this.actRoute.paramMap.subscribe((params: Params) => {
      if (!params) {
        return;
      }

      const id: number = params.get('id');
      if (id) {
        this.selectTabByIndex(id - 1);
      } else {
        this.selectTabByIndex(0);
      }
    });
  }

  loadDataForTab(tabId: string): void {
    switch (tabId) {
      case 'Faq':
        this.loadFaq();
        break;
      case 'Forms':
        this.loadFormData();
        break;
      case 'FactSheet':
        this.loadFactSheets();
        break;
    }
  }

  selectTabByIndex(tabId: number): void {
    // Render the tabs allowed by the API flags before indexing into them
    this.cd.detectChanges();
    const tab = this.staticTabs.tabs[tabId] ?? this.staticTabs.tabs[0];
    if (tab) {
      tab.active = true;
    }
    this.cd.detectChanges();
  }

  onTabClicked(data: TabDirective): void {
    this.loadDataForTab(data.id);
  }

  loadFaq(): void {
    if (this.FaqData) {
      return;
    }

    this.loadingFaq = true;
    this.apiService.getFaqByPage(this.pageId).subscribe(data => {
      this.FaqData = data;
      this.loadingFaq = false;
    });
  }

  loadFormData(): void {
    if (this.formDetails.length > 0) {
      return;
    }

    this.formDetails = [];
    this.loadingForms = true;
    this.apiService.getFormByPageNew(this.pageId).subscribe(async formDataEntries => {
      const promises: Promise<FormDetail>[] = [];

      for (const datum of formDataEntries) {
        promises.push(firstValueFrom(this.apiService.getForm(datum.formNumber)));
      }

      const results = await Promise.all(promises);
      const formDetails: FormDetail[] = [];

      for (const result of results) {
        formDetails.push(result);
      }

      this.formDetails = formDetails;
      this.FormData = formDataEntries;
      this.loadingForms = false;
    });
  }

  loadFactSheets(): void {
    if (this.factSheets.length > 0) {
      return;
    }

    this.loadingFactSheets = true;
    this.apiService.getFacts(this.pageId).subscribe(data => {
      if (data[0]) {
        this.factSheets = data;
      } else {
        this.enable = false;
      }
      this.loadingFactSheets = false;
    });
  }
}
